import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { put, select, takeLatest } from "redux-saga/effects";

import { callApi } from "../../../../sagas";
import State from "../../../../State";
import { Cognito } from "../../../../utils/cognito";
import errors from "../../../../utils/errors";
import * as actions from "./actions";
import { SAVE_FUELING_PROCESS_RECEIPT } from "./constants";

const getAccessToken = (state: State): string =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  state.session.session!.credentials.accessToken;

function* saveFuelingProcessReceipt(
  axiosClient: AxiosInstance,
  cognito: Cognito,
  action: actions.SaveFuelingProcessReceiptAction
) {
  try {
    const accessToken: string = yield select(getAccessToken);
    const requestConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      validateStatus: () => true,
    };

    const response: AxiosResponse<{ type: string; message?: string }> =
      yield callApi(
        cognito,
        accessToken,
        axiosClient.post,
        `/support/processes/${action.fuelingProcessId}/state`,
        {
          state: "processed",
          totalAmount: {
            amount: action.totalAmount,
            currency: action.currency,
          },
          quantity: action.quantity,
          price: {
            amount: action.price,
            currency: action.currency,
          },
        },
        requestConfig
      );

    const responseType = response.data?.type ?? "error";

    if (responseType === "ok") {
      yield put(actions.hideFuelingProcessReceiptEdit());
    } else {
      yield put(
        actions.saveFuelingProcessReceiptFailed(
          responseType,
          response.data?.message ?? ""
        )
      );
    }
  } catch (error) {
    yield put(
      actions.saveFuelingProcessReceiptFailed("error", errors.toString(error))
    );
  }
}

export function* watchSaveFuelingProcessReceipt(
  axiosClient: AxiosInstance,
  cognito: Cognito
) {
  yield takeLatest(
    SAVE_FUELING_PROCESS_RECEIPT,
    saveFuelingProcessReceipt,
    axiosClient,
    cognito
  );
}
